import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge reads an unknown text-* class as a colour, so it dropped the token font sizes (text-mp-sm,
// text-mp-base, text-mp-nav-size) whenever a token colour (text-mp-nav-text…) came after them. Tell it which are sizes.
const twMerge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': [{ text: ['mp-base', 'mp-sm', 'mp-nav-size'] }] } },
});

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx for conditional classes and tailwind-merge for deduplication
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
